import type { SiteTimeline } from '@/domain/fishGroups';
import type { StockingCycle } from '@/domain/stockingCycles';
import { getDemoDisplayName } from '@/utils/demoMasking';

type Translate = (key: string) => string;

/**
 * The board's names with demo masking applied: pens, groups and cycles become "Merd 1234"
 * style labels from their ids. Only display names change; every id stays real, because
 * requests and React keys depend on them.
 */
export function maskTimeline(timeline: SiteTimeline, t: Translate): SiteTimeline {
    return {
        ...timeline,
        cycle: timeline.cycle ? maskCycle(timeline.cycle, t) : null,
        groups: timeline.groups.map((group) => ({
            ...group,
            name: getDemoDisplayName(group.id, 'fishGroup', t),
            stays: group.stays.map((stay) => ({
                ...stay,
                cageName: getDemoDisplayName(stay.cageId, 'cage', t),
            })),
        })),
        externalGroups: timeline.externalGroups.map((group) => ({
            ...group,
            name: getDemoDisplayName(group.id, 'fishGroup', t),
        })),
    };
}

export function maskCycle(cycle: StockingCycle, t: Translate): StockingCycle {
    return { ...cycle, name: getDemoDisplayName(cycle.id, 'stockingCycle', t) };
}
